import { observer } from "mobx-react";
import useStore from "../../../store";
import { useEffect } from "react";
import PageHeader from '../../../component/PageHeader';
import { Form, Input } from 'antd';
import ListComponent from "./Component/ListComponent";
import { EnquiryBreadcrumb } from "../../../config/BreadcrumbConfig";

const Enquiry = observer(() => {
	const { ENQUIRY } = useStore();


	const onSearch = (text) => {
		if (text.length >= 3 || text.length === 0) {
			ENQUIRY.searchValue = text;
			ENQUIRY.setupGrid(ENQUIRY.agGrid);
		}
	};

	useEffect(() => {
		return () => {
			ENQUIRY.searchValue = '';
		};
	}, []);
	return (
		<div className="mainPageWrap">
			<PageHeader
				className="mainPageHeader"
				title={EnquiryBreadcrumb.title}
				extra={[
					<Form.Item help={'Write 3 letters to search'} key={1}>
						<Input
							placeholder="Search here"
							onChange={(e) => onSearch(e.target.value)}
						/>
					</Form.Item>
				]}
			/>
			<ListComponent/>
		</div>
	);
});

export default Enquiry;